/** Date picker selections are calendar days, not UTC timestamps. */
export const toDateFilterValue = (date: Date): string =>
	`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
		2,
		'0',
	)}-${String(date.getDate()).padStart(2, '0')}`;

export const fromDateFilterValue = (value: string): Date =>
	new Date(`${value.slice(0, 10)}T00:00:00`);

export const dateFilterCondition = (
	selection: string,
	operation: string,
): string => {
	const start = fromDateFilterValue(selection);
	const next = new Date(start);
	// Calendar arithmetic preserves the selected day across daylight saving changes.
	next.setDate(next.getDate() + 1);
	const lower = `ISODate('${start.toISOString()}')`;
	const upper = `ISODate('${next.toISOString()}')`;
	switch (operation) {
		case 'gte':
			return `{$gte:${lower}}`;
		case 'gt':
			return `{$gte:${upper}}`;
		case 'lte':
			return `{$lt:${upper}}`;
		case 'lt':
			return `{$lt:${lower}}`;
		case 'eq':
			return `{$gte:${lower},$lt:${upper}}`;
		case 'ne':
			return `{$not:{$gte:${lower},$lt:${upper}}}`;
		default:
			throw new Error(`Unsupported date filter operation: ${operation}`);
	}
};
